module.exports = __webpack_public_path__ + "img/corrugatedBox11.bf7e31c8.jpg";